import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'EMPRESAS',
      name: i18n.t('companies.header'),
    },
    {
      id: 'USUARIOS',
      name: i18n.t('users.header')
    },
    {
      id: 'ESPACIO',
      name: i18n.t('license.stored_space_short')
    },
    {
      id: 'FACTURAS',
      name: i18n.t('invoices.header')
    },
    {
      id: 'VOLUMEN',
      name: i18n.t('license.num_volumen_invoices_short')
    }
  ]
}

export function DASHBOARD_LICENCIAMIENTO (state) {
  return configHelper.getConfig(state, 'DASHBOARD_LICENCIAMIENTO', GenerateConfig)
}
